import React, { useState, useEffect } from 'react';
import { Tooltip } from '@mui/material';

const CustomTooltip = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => setOpen(false);
    const handleTouchMove = () => setOpen(false);
    const handleBlur = () => setOpen(false);

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('touchmove', handleTouchMove);
    window.addEventListener('blur', handleBlur);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);

  return (
    <Tooltip
      title={title}
      arrow
      open={open}
      onOpen={() => setOpen(true)}
      onClose={handleClose}
      enterTouchDelay={0}
      leaveTouchDelay={100000}
      PopperProps={{
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              padding: 8,
            },
          },
        ],
      }}
    >
      <span>
        {children}
      </span>
    </Tooltip>
  );
};

export default CustomTooltip;
